<template>
  <label
    v-if="label"
    :for="inputId"
    :class="fieldControlUi.formField.label"
  >
    {{ label }}
    <span
      v-if="required"
      class="text-danger-text"
      aria-hidden="true"
      >*</span
    >
  </label>

  <template v-else />
</template>

<script setup lang="ts">
import { fieldControlUi } from '~/design-system/base/fieldControlUi'

withDefaults(
  defineProps<{
    /** Accessible name displayed above the input. */
    label: string
    /** Identifier of the native input named by this label. */
    inputId: string
    /** Displays the visual required marker; the input owns aria-required. */
    required?: boolean
  }>(),
  { required: false }
)
</script>
